const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/auth/account-locked.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/auth/account-locked')({
  validateSearch: search => ({
    email: typeof search.email === 'string' ? search.email : '',
    /** 잠금이 풀리는 시각(ISO). 남은 분을 숫자로 받으면 화면에 머무는 동안 줄지 않는다 */
    lockExpiresAt: typeof search.lockExpiresAt === 'string' ? search.lockExpiresAt : ''
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});

/** 인증번호 확인 → 새 비밀번호 설정 두 단계로 진행한다 */
type Step = 'code' | 'password';
export function TSRDummyComponent() {
  return null;
}